import { UNIT } from '../../../../constant/unit'
import { HEIGHT_UNIT_METER_PER_FOOT } from '../../constants/unit'

export function getFeetHeightUtil (height, heightUnit) {
  if (heightUnit === UNIT.IMPERIAL) {
    return height
  }
  return parseFloat((
    height / HEIGHT_UNIT_METER_PER_FOOT
  ).toFixed(2))
}
